import "./Terms&Conditions.css";
export default function TermsAndConditions() {
  return (
    <>
      <div className="terms-condition-main-container">
        <div className="terms-condition-container">
          <div className="tc-starting-point-container">
            <div className="terms-condition-title">Terms and Conditions</div>
            <div className="terms-condition-description">
              This Terms of Service Agreement (the "Agreement") outlines the
              terms and conditions under which you (the "Client") have engaged
              Hussme to provide specific services as defined herein. This is
              a legally binding agreement between you and Hussme. By
              becoming a Hussme Client, you agree to abide by the terms and
              conditions set forth in this Agreement. The "Effective Date" of
              this Agreement will be the date on which you submit your order for
              Services to Hussme.
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">1. Services</div>
            <div className="terms-condition-description">
              Hussme will provide Services to Client as detailed on the Hussme
              website <strong>(www.hussme.com)</strong>. This agreement
              overrides all previous agreements and is presented to you during
              sign-up for your approval. It is your responsibility to thoroughly
              read these terms to fully understand what you are agreeing to.{" "}
              <br />
              <div className="terms-condition-blank-row"></div>
              <strong className="terms-condition-strong-text">1.1 </strong>{" "}
              Given the nature of working with third-party platforms such as
              Facebook, Instagram, Twitter, Google My Business, Pinterest, and
              LinkedIn, we sometimes have no control over issues that may arise,
              such as disconnections or password changes. If you alter your
              password, you are required to notify Hussme promptly to
              prevent any service interruption. It is recommended to review your
              accounts and our work at least once a week, as well as provide us
              with guidance and feedback. In the event of a disconnect or an
              inability to access the account for posting, the client agrees to
              not hold Hussme accountable. As long as we continue creating
              content for your business, we are fulfilling our service as
              described. If we lack access to any platforms, we can compensate
              for any missed posts by posting twice a day until the backlog of
              missed posts is cleared. Missed posts due to account lockouts that
              are not the fault of Hussme do not qualify for a refund. Keep
              reading for information on our cancellation and refund policies.
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              2. Hussme Obligations
            </div>
            <div className="terms-condition-description">
              <strong className="terms-condition-strong-text">2.1 </strong> Hussme
              will provide Services to the Client following Hussme's
              standard policies and procedures. Hussme retains the right to
              decline Clients for any reason, at Hussme's sole discretion.
              Hussme will manage all aspects of providing the Services.
              <div className="terms-condition-blank-row"></div>
              <strong className="terms-condition-strong-text">2.2 </strong> All
              Hussme rules, policies, and operating procedures concerning
              privacy, pricing, customer service, and all other service aspects
              will apply, and Hussme may modify its rules, policies, and
              operating procedures at its sole discretion from time to time.
              This includes pricing, package inclusions, and more. You may be
              grandfathered into an archived product if we can still offer it,
              but that decision lies at Hussme's sole discretion.
            </div>
          </div>

          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              3. Services, Fees, and Payment
            </div>
            <div className="terms-condition-subheading">
              How we use collected information
            </div>
            <div className="terms-condition-description">
              <strong className="terms-condition-strong-text">3.1 </strong> All
              fees for Services rendered to the Client are due in full, payable
              in advance of the provision of Services. A valid credit card for
              monthly payment of fees should be securely maintained on file to
              cover recurring charges for service.
              <div className="terms-condition-blank-row"></div>
              <strong className="terms-condition-strong-text">3.2 </strong>{" "}
              Initial service charges must be paid in advance. Subsequently, Hussme
              will attempt to charge the Client’s credit card on the
              monthly anniversary of the client's initial order of services. Any
              charges not paid by the due date will lead to a suspension of
              Services until full payment is secured. Suspension of Services due
              to non-payment does not warrant a proration of fees.
              <div className="terms-condition-blank-row"></div>
              <strong className="terms-condition-strong-text">3.3 </strong>{" "}
              Refund Policy - Except in cases where Hussme materially
              breaches this agreement, Hussme does not issue refunds of any
              fees beyond the 14-day money-back guarantee, which applies only to
              your initial order of social media content services, specifically:
              Social Media Management, Short Form Reels Content.
              <div className="terms-condition-blank-row"></div>
              The 14-day money-back guarantee does not apply to any other
              services, including but not limited to: Ad Management (Meta Ads,
              Google Ads, TikTok Ads), SEO Services, Instagram Growth, Any
              additional or custom services.
              <div className="terms-condition-blank-row"></div> Refunds
              requested within the eligible 14-day window will only be processed
              after all related social media content has been deleted from your
              pages. You also agree not to use any content created by Hussme
              for your business once a refund has been issued.
              <div className="terms-condition-blank-row"></div> All fees paid to
              Hussme are compensation for time and labor performed and are
              not contingent on marketing results. Hussme may issue service
              credits in the case of substantiated errors on our part.
              <div className="terms-condition-blank-row"></div>
              <strong className="terms-condition-strong-text">3.4 </strong>{" "}
              Cancellation Policy – Cancellations are entirely self-service, and
              you can cancel a subscription via your client portal by signing in
              here: https://clients.hussme.com and visiting the
              'subscriptions' section. We do not issue prorated refunds for
              cancellations made early in a billing period, but we will complete
              the remaining month(s) if requested (this includes multi-month
              plans where the client received a discount; however, we will
              require the discounted price to be voided and the difference paid
              before the continuation of service).{" "}
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.5 </strong>{" "}
              Continued work on a past-due client who did not cancel will result
              in accrued back-payments due, but we do not charge interest. We
              commit to maintaining precise records of all communication and
              work performed to justify the back-payment due.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.6 </strong> Our
              Services officially begin on the day you sign up, and we initiate
              the onboarding process, not when we make the first post. We do not
              charge a setup fee for this reason. This setup work and onboarding
              fee are included in the monthly payment. If onboarding extends
              beyond seven business days due to a delay by Hussme, we will
              adjust your billing date to ensure you receive a full month of
              service once you are onboarded with at least one profile.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.7 </strong> This
              Agreement will supersede all other agreements between the Parties
              on the same subject matter, including any agreements,
              instructions, or claims made by Hussme's employees, unless a
              formal variance is confirmed and agreed upon by the client and
              executive-level management at Hussme, including the CEO of Hussme.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.8 </strong>{" "}
              Posting to Multiple Platforms and Missed Posts – In case your
              social media pages get disconnected from our posting software, you
              will be automatically notified to reconnect your profiles. If you
              fail to reconnect your profiles, it is your responsibility, and
              Hussme will not be held liable or issue any credit or partial
              refunds. However, we will reschedule the posts as soon as you
              reconnect your pages. We advise our clients to check their social
              media accounts twice a week, not just to review content and
              provide feedback, but also to alert us of any possible disconnects
              so we can promptly reconnect. For this reason, if Hussme is
              creating social media posts and sending them to the client for
              review in any format, then we are fulfilling our contractual
              obligation as laid out in our terms and conditions.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.9 </strong> Post
              Quality – Social media management is a highly tailored service;
              preferences can vary widely from one client to another. If you
              would like to approve social media posts before they are
              automatically shared on your profiles, the Content Panel must be
              included in your chosen plan. This feature is standard in our Pro,
              Growth, and Premium Social Media Posts Plans. If the Content Panel
              isn't included, we will send you the posts for manual sharing.{" "}
              <div className="terms-condition-blank-row"></div> Any
              typographical errors or posts shared on the wrong day (e.g., a
              Christmas Day post shared on December 28th) usually occur due to
              adjustments that alter the date queue in our publishing software.
              In such instances, we will offer a credit of 5% (approximately the
              cost of a single post) based on your package level per post issue.
              We do not issue refunds for typographical errors or date
              mismatches. Despite our “No typo policy” and penalties imposed on
              our social media designers/writers, you agree to accept credit for
              all such incidents.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.10 </strong>{" "}
              Content Review and Approval – All plans continue to be fulfilled
              even in the absence of client feedback or approval of the content.
              Unless the plan is cancelled, Hussme will continue to provide
              services. If a client fails to approve content for any period,
              they can resume the approval process whenever they are ready. Our
              policy is to pause billing while the previously created backlog of
              plans gets approved and posted to the client’s account. At this
              point, the client can either cancel or resume normal billing. The
              client agrees to one round of edits per week of plans.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.11 </strong>{" "}
              Regular Reviews – You agree to consistently review your content
              panel and social media accounts, dedicating approximately 10
              minutes every other week to ensure our posts meet your
              expectations and no platforms are missing posts. Hussme is not
              responsible for missed posts on any platforms due to
              uncontrollable disconnects like changed passwords or security
              lockouts, or for editing/removing content that has been posted
              over two weeks ago or longer.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.12 </strong>{" "}
              Blog Posts – After the completion of the first draft, a maximum of
              two revisions are allowed, after which the delivered product will
              be deemed final. All blog articles are considered final and
              approved after 4 weeks of receiving no feedback. After this
              period, you agree that no further revisions will be made.{" "}
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.13 </strong>{" "}
              Reseller Program– All terms and conditions within this agreement
              apply to any customers you introduce as a reseller. We recommend
              using our agreement as a template for your clients to sign a
              similar document. Resellers must pay for services in advance for
              their clients, and it is the reseller's sole responsibility to
              collect payment from their customers. If your customer fails to
              pay you, we will not issue a refund for the services rendered. As
              a reseller, you must inform us promptly if any of your customers
              are cancelling. If we are not properly notified of the
              cancellation as described in this agreement and continue to
              provide services, you will be fully responsible for the payment of
              these services. No refund policy is in place once a client has
              been onboarded. The reseller's responsibilities also include
              managing and facilitating timely client communication between your
              client and Hussme. Delays in communication can lead to various
              issues, and we will not issue refunds for missed posts due to
              disconnects; reviewing social content and connections as described
              in this agreement is your responsibility.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.14 </strong>{" "}
              Disputes – In the event of a client breaching our terms and
              conditions, we will resolutely defend our position, utilizing
              legal avenues when necessary. Your account will then be forwarded
              to a debt collection agency, and we will report you to all three
              credit reference agencies.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.15 </strong>{" "}
              Less Tech-Savvy Clients – We understand that not all clients may
              be familiar with technology, various software, or even the
              workings of social media. That's why we invest a considerable
              amount of time in onboarding your account to ensure the delivery
              of our service. This includes time spent explaining the process,
              exchanging emails, and participating in phone calls. This all
              counts as time spent serving your account. Please note, if you
              choose to cancel after the 14-day money-back guarantee period, no
              refunds will be provided. However, you are welcome to continue
              using our services until the end of the paid month. Your decision
              to cancel due to frustration does not discount the time and work
              we've already invested in your account.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.16 </strong>{" "}
              Resellers – If you join us as a Reseller using your Cloud Campaign
              account and then decide to cancel that account, we must halt your
              services immediately until we can onboard you onto our platform.
              If you cancel your Cloud Campaign without prior notice and do not
              wish to continue with Hussme service, you will forfeit the
              remaining balance of the month's fees with no prorated refunds
              provided. Please note that Hussme and Cloud Campaign are two
              separate entities, so if you wish to cancel both accounts, you'll
              need to do so on each platform individually.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.17 </strong>{" "}
              Business Structure and Client Phone Communication – As an online
              subscription-based social media service rather than a full-service
              marketing agency, our customer service is focused on inbound
              communication. This means you have the responsibility of regularly
              checking your social media pages/Content Panel on all plans and
              providing feedback if necessary. As a budget-friendly social media
              management company, our major expenses lie in customer support.
              Therefore, we use a call booking system. Before signing up, we
              provide a free 30-minute consultation call. This gives you the
              chance to understand more about our service and have all your
              queries answered before starting. Once you become a customer, we
              also offer a free 15-minute onboarding call. However, post the
              onboarding call, all customer support is online to maintain our
              low-cost services. Our customer support team is ready to assist
              you via live chat, email, or tickets via the client portal. Please
              avoid booking customer support calls as they will be cancelled.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">3.18 </strong>{" "}
              Please familiarize yourself with our Phone Support Policy Here:
              https://hussme.com/
              <div className="terms-condition-blank-row"></div>{" "}
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              4. Warranty Disclaimers
            </div>
            <div className="terms-condition-description">
              <strong className="terms-condition-strong-text">4.1 </strong>
              REFUND POLICY – Once the payment has been made and the 14-day
              money-back guarantee period has lapsed, no refunds will be issued.
              As outlined throughout these terms and conditions, due to the
              nature of operating on third-party platforms, instances of
              disconnection, delayed review of our work by clients, and our
              operation as a monthly subscription service (rather than a
              full-service agency), we offer absolutely no refunds. In the event
              that we fail to create at least one post per week, you agree to
              accept credit equivalent to the value of that post.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">4.2 </strong>
              Hussme SPECIFICALLY DISCLAIMS ANY AND ALL WARRANTIES RELATED
              TO THIS AGREEMENT, THE SERVICES, OR ANY SUPPORT OR MATERIALS
              PROVIDED TO THE CLIENT, BE THEY EXPRESS OR IMPLIED. THIS INCLUDES
              BUT IS NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, CONSISTENCY
              OF PERFORMANCE OR DEALING, TRADE PRACTICE, TITLE,
              NON-INFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE.
              <div className="terms-condition-blank-row"></div>{" "}
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">5. Indemnity</div>
            <div className="terms-condition-description">
              <strong className="terms-condition-strong-text">5.1 </strong>
              The client agrees to indemnify and hold harmless Hussme, its
              customers, suppliers, directors, officers, agents, and employees
              from and against any and all losses, costs, damages, liabilities,
              and expenses (including, without limitation, reasonable attorneys`
              fees) resulting from or connected to any violation of the terms of
              this Agreement by the client.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">5.2 </strong>
              Social Media Account Suspensions, Access Loss, or Deletion – The
              client agrees to indemnify and hold harmless Hussme, its
              customers, suppliers, directors, officers, agents, and employees
              from and against any and all losses, costs, damages, liabilities,
              and expenses (including, without limitation, reasonable attorneys`
              fees) related to issues such as social media account suspensions,
              copyright disputes, unintentional loss of access, account
              deletion, or any other issues concerning third-party platforms.
              Factors leading to a social media account suspension or
              disablement may include, but are not limited to, the usage of bots
              or plug-ins that violate the social platform's TOS, setting up a
              personal account as a business account, failing to verify your
              account (e.g., not verifying your Twitter or Instagram account
              with an email and frequently adding a phone number that can
              receive texts to confirm the account), personal accounts should
              display a real person's photo, not a logo, and should behave as a
              person, not a business. As previously mentioned, you are required
              to log into your content panel or social media accounts regularly
              (weekly is standard, but at least once a month) to ensure they
              remain active and don't get flagged due to constant posts without
              the account owner ever logging in. This is a crucial
              responsibility for you, the client. This clause also applies to a
              reseller's client, and you are required to have them sign a
              similar contract.
              <div className="terms-condition-blank-row"></div>{" "}
              <strong className="terms-condition-strong-text">5.3 </strong>
              Hussme uses only images provided by the client or selected
              from several databases offering royalty-free images for marketing
              purposes when creating graphics for posts. We pay for many of
              these services. Nevertheless, the client will indemnify and hold
              harmless Hussme and its customers, suppliers, directors,
              officers, agents, and employees from and against any and all
              losses, costs, damages, liabilities, and expenses (including,
              without limitation, reasonable attorneys` fees) arising out of or
              relating to any issues with content posted on a client's social
              media account that result in any claims of copyright infringement.
              The client agrees to assume full responsibility for the content
              posted on their accounts.
              <div className="terms-condition-blank-row"></div>{" "}
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              Sharing your personal information
            </div>
            <div className="terms-condition-description">
              We do not sell, trade, or rent Users personal identification
              information to others. We may share generic aggregated demographic
              information not linked to any personal identification information
              regarding visitors and users with our business partners, trusted
              affiliates and advertisers for the purposes outlined above. We may
              use third party service providers to help us operate our business
              and the Site or administer activities on our behalf, such as
              sending out newsletters or surveys. We may share your information
              with these third parties for those limited purposes provided that
              you have given us your permission. All the above categories
              exclude text messaging originator opt-in data and consent; this
              information will not be shared with any third parties.
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              6. Limitation of Liability
            </div>
            <div className="terms-condition-description">
              HUSSME SHALL NOT BE LIABLE TO THE CLIENT OR ANY ENTITY OR
              PERSON CLAIMING THROUGH OR UNDER THE CLIENT FOR ANY LOSS OF PROFIT
              OR INCOME OR OTHER INDIRECT, CONSEQUENTIAL, INCIDENTAL, OR SPECIAL
              DAMAGES, WHETHER IN AN ACTION FOR CONTRACT OR TORT, IN CONNECTION
              WITH THIS AGREEMENT, EVEN IF Hussme HAS BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL Hussme's
              LIABILITY TO THE CLIENT HEREUNDER EXCEED THE AMOUNT PAID TO Hussme
              BY THE CLIENT FOR THE PREVIOUS ONE (1) MONTH OF SERVICES.
              THIS LIMIT IS CUMULATIVE AND THE EXISTENCE OF MORE THAN ONE CLAIM
              WILL NOT ENLARGE THE LIMIT. THE CLIENT ACKNOWLEDGES THAT THESE
              LIMITATIONS OF LIABILITY ARE AN ESSENTIAL ELEMENT OF THE BARGAIN
              BETWEEN THE PARTIES AND IN THEIR ABSENCE, THE TERMS AND CONDITIONS
              OF THIS AGREEMENT WOULD BE SUBSTANTIALLY DIFFERENT.
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">7. Miscellaneous</div>
            <div className="terms-condition-description">
              This Agreement constitutes the entire understanding and agreement
              of the parties with respect to its subject matter. This Agreement
              may be amended from time to time in Hussme’s sole discretion,
              with the most current agreement always published here. An email
              communication sent to the Client’s last known email address will
              be deemed sufficient notice of any such changes in this Agreement.
              This Agreement shall bind upon and benefit the parties' successors
              and permitted assigns; however, the Client may not assign this
              Agreement, in whole or in part, without Hussme’s prior written
              consent and any assignment by the Client without such consent
              shall be null and void. This Agreement shall be governed by and
              interpreted in accordance with the laws of the location where Hussme
              operates, without regard to its conflict of law rules. Any
              litigation or dispute resolution related to this Agreement shall
              take place in the jurisdiction where Hussme operates, and the
              parties hereby consent to the jurisdiction of the courts located
              therein. Except as otherwise expressly set forth herein, any
              notice required or permitted to be given under this Agreement
              shall be sufficient if in writing, in the English language, and
              sent via the equivalent of the U.K. Royal Mail, return receipt
              requested. If any provision of this Agreement shall be held by a
              court of competent jurisdiction to be unenforceable, that
              provision will be severed only to the extent minimally necessary,
              and the remaining provisions of this Agreement will remain in full
              force and effect. The waiver of any breach or default of this
              Agreement will not constitute a waiver of any subsequent breach or
              default, and will not act to amend or negate the rights of the
              waiving party.
            </div>
          </div>
          <div className="tc-common-point-container">
            <div className="terms-condition-normal-title">
              8. Credit Card Disputes
            </div>
            <div className="terms-condition-description">
              In the event of a credit card dispute, all credits, refunds, and
              account work come to a halt until the dispute is resolved.
              Resolving a dispute can take one to three months, sometimes
              longer. Negotiating a fair compromise and credit will always be
              more favorable than filing a dispute in almost all cases. We are
              always willing to negotiate a favorable outcome for both parties.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

